var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBordercruve1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1005_6963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M781.599 23.5385C769.939 23.5385 760.463 14.0522 760.463 2.40108C760.463 1.07261 759.391 0 758.062 0H25.9477C24.6193 0 23.5468 1.07261 23.5468 2.40108C23.5468 14.0522 14.0611 23.5385 2.40092 23.5385C1.07254 23.5385 0 24.6111 0 25.9396V526.06C0 527.389 1.07254 528.462 2.40092 528.462C14.0611 528.462 23.5468 537.948 23.5468 549.599C23.5468 550.927 24.6193 552 25.9477 552H758.062C759.391 552 760.463 550.927 760.463 549.599C760.463 537.948 769.939 528.462 781.599 528.462C782.927 528.462 784 527.389 784 526.06V25.9396C784 24.6111 782.927 23.5385 781.599 23.5385ZM779.198 523.768C766.81 524.909 756.911 534.809 755.769 547.198H28.2404C27.1088 534.809 17.2099 524.909 4.81169 523.768V28.2422C17.2099 27.1007 27.1088 17.2012 28.2404 4.812H755.769C756.911 17.2012 766.81 27.1007 779.198 28.2422V523.768Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1005_6963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordercruve1);
export default __webpack_public_path__ + "static/media/bordercruve1.f72d017114e377596c2686925c38fcff.svg";
export { ForwardRef as ReactComponent };